import React from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core";
import { Table, TableBody, TableCell, TableRow, Checkbox, Typography, Button, TableHead } from "@mui/material";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import { useTheme } from "@mui/material/styles";
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { parsePrice } from "src/utils/parse-price";

const useStyles = makeStyles((theme) => ({
  tableContainer: {
    overflowX: "auto",
    maxWidth: "100%",
  },
  staticColumn: {
    position: "sticky",
    left: 0,
    zIndex: 1,
    border: 0,
    width: 250,
    flexShrink: 0,
    fontWeight: "bold",
    fontSize: "18px",
  },
}));

const PlansFeaturesTable = ({ plans, billingType, showBuyButtons, handleBuyPlan, userPlan, prices, customerPaymentMethods }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const theme = useTheme();

  return (
    <div className={classes.tableContainer}>
      <Table sx={{ minWidth: 700, maxWidth: 800, mx: 'auto' }}>
        <TableHead>
          { showBuyButtons ? (
            <TableRow>
              <TableCell sx={{width: '250px', fontSize: '20px', fontWeight: '700' }}>
                {t("views.subscriptions.choosePlan")}
              </TableCell>
              {plans?.length !== 0 ? (
                plans.filter(pi => !pi.hidden).map((plan) => (
                  <TableCell key={plan._id} align="center">
                    {plan.paid ? (userPlan?._id !== plan._id ? (!userPlan?.paid ? (
                      <Button variant="contained" onClick={() => handleBuyPlan(plan, 'create')} disabled={customerPaymentMethods?.length == 0}>{t("views.subscriptions.buy")}</Button>
                    ) : (
                      <Button variant="contained" onClick={() => handleBuyPlan(plan, 'edit')} disabled={customerPaymentMethods?.length == 0}>{t("views.subscriptions.choose")}</Button>
                    )) : (
                      <Button disabled>{t("views.subscriptions.current")}</Button>
                    ) ) : null} 
                  </TableCell>
                ))
              ) : (
                <TableCell></TableCell>
              )}
            </TableRow>
          ) : null }
          <TableRow>
            <TableCell sx={{width: '250px', fontSize: '20px', fontWeight: '700' }}>
              {t("views.subscriptions.featureName")}
            </TableCell>
            {plans?.length !== 0 &&
              plans.filter(pi => !pi.hidden).map((plan) => (
                <TableCell key={plan._id} align="center">
                    <Typography variant="h6">
                        {plan.name}
                    </Typography>
                </TableCell>
              ))}
          </TableRow>
          <TableRow>
            <TableCell sx={{width: '250px', fontSize: '20px', fontWeight: '700' }}>
              {billingType == 'month' ? (
                "Monthly subscription"
              ) : (
                "Annual subscription"
              )}
            </TableCell>
            {plans.filter(pi => !pi.hidden).map((plan, planIndex) => {
                  return prices?.length > 0 ? (
                    <TableCell key={plan._id} align="center">
                        {prices.find(p => p.product == plan.productId && p.recurring.interval == billingType) ? (
                          billingType == 'year' ? (
                            parsePrice(Math.round(prices.find(p => p.product == plan.productId && p.recurring.interval == billingType)?.unit_amount/12))
                          ) : (
                            parsePrice(prices.find(p => p.product == plan.productId && p.recurring.interval == billingType)?.unit_amount)
                          )
                        ) : (
                          <Typography variant="caption">{t("views.subscriptions.noPrice")}</Typography>
                        )}
                    </TableCell>
                  ) : null
            })}
          </TableRow>
          </TableHead>
          <TableBody>
          {plans?.length !== 0 &&
            plans[0].planFeatures.map((planFeature, featureIndex) => (
              <TableRow key={planFeature._id}>
                <TableCell sx={{width: '250px', fontWeight: '400' }}>
                  {planFeature.name.includes('#') ? planFeature.name.slice(planFeature.name.indexOf(' ')) : planFeature.name}
                </TableCell>
                {plans.filter(pi => !pi.hidden).map((plan, planIndex) => {
                  const value = plan.planFeatures[featureIndex].value;
                  const regex = new RegExp(plan.planFeatures[featureIndex].regex);
                  let error = false;

                  if (regex && value.toString().match(regex) === null) {
                    error = true;
                  }

                  return (
                    <TableCell key={plan._id} align="center">
                      {plan.planFeatures[featureIndex].enabled ? (
                        <CheckIcon color="success"/>
                      ) : (
                        <CloseIcon htmlColor="#DC3545"/>
                      )}
                    </TableCell>
                  );
                })}
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default PlansFeaturesTable;
